import React from 'react'
import { Col } from 'react-bootstrap'

const ReusableProductsTop = ({img}) => {
  return (
    <Col lg={4} xs={6}>
          <div class="products_top_main">
            <div class="products_top_img">
              <img src={img} class="w-100" alt=""/>
              <div class="products_top_img_overlay">
                <div class="icon"><i class="fa-regular fa-heart"></i></div>
                <div class="icon"><i class="fa-solid fa-magnifying-glass"></i></div>
                <div class="icon"><i class="fa-solid fa-arrow-right-arrow-left"></i></div>
                <div class="icon"><i class="fa-solid fa-cart-shopping"></i></div>
             </div>
            </div>
            <div class="products_top_text text-center">
              <ul class="icson">
                <li ><i class="fa-solid fa-star"></i></li>
                <li ><i class="fa-solid fa-star"></i></li>
                <li ><i class="fa-solid fa-star"></i></li>
                <li><i class="fa-solid fa-star"></i></li>
                <li ><i class="fa-solid fa-star"></i></li>
             </ul>
             <p>$8.00-9.00</p>
             <h4>Organic Fresh Vegetables</h4>
            </div>
          </div>
    </Col>
  )
}

export default ReusableProductsTop